import React from "react";
import styles from "./fields.module.css";

export interface PhoneFieldProps {
  id?: string;
  label: string;
  value: string;
  prefix?: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  icon?: React.ReactNode;
}

export const PhoneField: React.FC<PhoneFieldProps> = ({
  id,
  label,
  value,
  prefix,
  onChange,
  onBlur,
  placeholder,
  required,
  disabled,
  error,
  icon,
}) => {
  const displayValue =
    prefix && value.startsWith(prefix) ? value.slice(prefix.length) : value;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = prefix
      ? e.target.value.replace(/[^\d]/g, "")
      : e.target.value.replace(/[^\d+]/g, "");
    const fullValue = prefix ? `${prefix}${raw}` : raw;
    onChange(fullValue);
  };

  return (
    <div className={styles.container}>
      <label className={styles.label} htmlFor={id}>
        {label} {required && <span className={styles.required}>*</span>}
      </label>
      <div className={styles.phoneWrapper} data-error={error ? "" : undefined}>
        {prefix && <span className={styles.phonePrefix}>{prefix}</span>}
        {icon && <span className={styles.phoneIconArea}>{icon}</span>}
        <input
          id={id}
          type="tel"
          className={styles.phoneInput}
          placeholder={placeholder}
          value={displayValue}
          onChange={handleChange}
          onBlur={onBlur}
          required={required}
          disabled={disabled}
        />
      </div>
      {error && <span className={styles.errorText}>{error}</span>}
    </div>
  );
};
